import * as yup from 'yup';

/** Limites aceitos pelo cms-api (SETTINGS_LIMITS em recommendation-showcase.settings.ts). */
export const LIMITES = {
  size: { min: 3, max: 10 },
  min_products: { min: 1, max: 10 },
  min_cooccurrence: { min: 1, max: 50 },
  months: { min: 1, max: 3 },
  limit: { min: 5, max: 20 },
} as const;

export const TAMANHO_MAXIMO_TITULO = 60;
export const TAMANHO_MAXIMO_SUBTITULO = 120;

// campo numérico vazio ('' ou NaN) vira undefined para cair no "obrigatório"
const numeroInteiro = (
  rotulo: string,
  { min, max }: { min: number; max: number },
) =>
  yup
    .number()
    .transform((valor, original) =>
      original === '' || original === null || Number.isNaN(valor)
        ? undefined
        : valor,
    )
    .typeError(`${rotulo}: informe um número`)
    .required(`${rotulo}: campo obrigatório`)
    .integer(`${rotulo}: use um número inteiro`)
    .min(min, `${rotulo}: mínimo ${min}`)
    .max(max, `${rotulo}: máximo ${max}`);

const schemaVitrine = yup.object().shape({
  active: yup.boolean().required(),
  title: yup
    .string()
    .max(
      TAMANHO_MAXIMO_TITULO,
      `Máximo de ${TAMANHO_MAXIMO_TITULO} caracteres`,
    ),
  subtitle: yup
    .string()
    .max(
      TAMANHO_MAXIMO_SUBTITULO,
      `Máximo de ${TAMANHO_MAXIMO_SUBTITULO} caracteres`,
    ),
  size: numeroInteiro('Quantidade máxima', LIMITES.size),
  // .test em vez de .max(yup.ref('size')): com size vazio o ref acusaria erro falso
  min_products: numeroInteiro('Mínimo de produtos', LIMITES.min_products).test(
    'minimo-ate-o-tamanho',
    'Não pode ser maior que a quantidade máxima de produtos',
    function validarMinimo(minimo) {
      const { size } = this.parent;
      if (minimo === undefined || minimo === null) return true;
      if (typeof size !== 'number' || Number.isNaN(size)) return true;
      return minimo <= size;
    },
  ),
  position: yup
    .mixed()
    .oneOf(['apos_avaliacoes', 'apos_compre_junto'], 'Escolha a posição'),
  rank_by: yup.mixed().oneOf(['confidence', 'lift'], 'Escolha o ranking'),
  mode: yup.mixed().oneOf(['any', 'all', 'interleave'], 'Escolha o modo'),
  min_cooccurrence: numeroInteiro(
    'Mínimo de pedidos juntos',
    LIMITES.min_cooccurrence,
  ),
  months: numeroInteiro('Janela de pedidos', LIMITES.months),
  limit: numeroInteiro('Produtos pedidos', LIMITES.limit).test(
    'limite-maior-ou-igual-ao-tamanho',
    'Precisa ser maior ou igual à quantidade máxima de produtos',
    function validarLimite(limite) {
      const { size } = this.parent;
      if (limite === undefined || limite === null) return true;
      if (typeof size !== 'number' || Number.isNaN(size)) return true;
      return limite >= size;
    },
  ),
  schedule_start: yup
    .date()
    .typeError('Data de início é obrigatória')
    .nullable()
    .required('Data de início é obrigatória'),
  // fim é opcional; quando existe precisa ser depois do início
  schedule_end: yup
    .date()
    .typeError('Data final inválida')
    .nullable()
    .test(
      'fim-depois-do-inicio',
      'Data final deve ser superior a data inicial',
      function validarFim(fim) {
        const { schedule_start: inicio } = this.parent;
        if (!fim || !inicio) return true;
        return fim.getTime() > new Date(inicio).getTime();
      },
    ),
});

export default schemaVitrine;
